import { type IAPIResponse, type IEmployer } from "@/types";
import { baseApi } from "@/core/api/baseApi";
import type { MediworksSourceFilterBody } from "@/types/mediworksSourceFilter";

export interface IEmployerParams {
  name?: string;
  clientId?: number;
  isActive?: string;
  pageNo?: number;
  pageSize?: number;
}

interface IGlobalSearchParams {
  query: string;
  pageNo?: number;
  pageSize?: number;
}

export const employersApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getEmployers: build.query<IAPIResponse<IEmployer>, IEmployerParams>({
      query: (body) => ({
        url: `/mediworks/employers`,
        method: "POST",
        body,
      }),
    }),
    getEmployersBySource: build.query<
      IAPIResponse<IEmployer>,
      { entityId: number; body: MediworksSourceFilterBody }
    >({
      query: ({ entityId, body }) => ({
        url: `mediworks/employer/${entityId}`,
        method: "GET",
        body,
      }),
      transformResponse: (response: {
        data?: IEmployer | IEmployer[];
        totalCount?: number;
        [key: string]: unknown;
      }): IAPIResponse<IEmployer> => {
        const data = response.data;
        const list = Array.isArray(data) ? data : data ? [data] : [];
        return {
          data: list,
          totalCount: response.totalCount ?? list.length,
          pageNo: 1,
          pageSize: list.length || 10,
          currentPage: 1,
          totalPages: list.length ? 1 : 0,
        };
      },
    }),
    searchGlobalEmployers: build.query<IAPIResponse<IEmployer>, IGlobalSearchParams>({
      query: ({ query, pageNo = 1, pageSize = 100 }) => ({
        url: `/mediworks/employers/global-search`,
        method: "GET",
        params: { query, pageNo, pageSize },
      }),
    }),
    listEmployers: build.query<IEmployer[], void>({
      query: () => ({
        url: `/mediworks/employers/fetch-id-name`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetEmployersQuery,
  useGetEmployersBySourceQuery,
  useSearchGlobalEmployersQuery,
  useListEmployersQuery,
} = employersApi;
